/**
 * @generated SignedSource<<e6d6b6435ad4f0aef47b726f87bb5e61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NakamaIDAvatarQuery$variables = {
  id: string;
};
export type NakamaIDAvatarQuery$data = {
  readonly userFromNakamaID: {
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar">;
  } | null;
};
export type NakamaIDAvatarQuery = {
  response: NakamaIDAvatarQuery$data;
  variables: NakamaIDAvatarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "nakamaID",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NakamaIDAvatarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userFromNakamaID",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserAvatar"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NakamaIDAvatarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userFromNakamaID",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usernameID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avatarURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f778a660cb9fdaf8740c3e311051bb29",
    "id": null,
    "metadata": {},
    "name": "NakamaIDAvatarQuery",
    "operationKind": "query",
    "text": "query NakamaIDAvatarQuery(\n  $id: String!\n) {\n  userFromNakamaID(nakamaID: $id) {\n    ...UserAvatar\n    id\n  }\n}\n\nfragment UserAvatar on User {\n  username\n  usernameID\n  avatarURL\n}\n"
  }
};
})();

(node as any).hash = "daa437fc98ece81599db1825d60fd33b";

export default node;
